// extracted by mini-css-extract-plugin
module.exports = {"root__div":"DrawerSeparator_root__div__2LJVK","separator":"DrawerSeparator_separator__3AWbP"};